import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';


import {
  BsAuthService,
  BsCacheService,
  BsHubService
} from "@brightside-web/desktop/data-access/core-services";

import { FirebaseService, CompanyService, RequiredVerificationsEnums } from '@brightside-web/desktop/data-access/shared';
import {Environment} from "@micro-core/environment";

@Component({
  selector: 'brightside-web-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit, OnDestroy {
  isProd: boolean;

  sub = new Subscription();
  signupData: any = {};

  company:string;

  constructor(
    protected analytics: FirebaseService,
    private _companyService: CompanyService,
    private _env: Environment,
    private _bsAuthService: BsAuthService,
    private _bsCacheService: BsCacheService,
    private _bsHubService: BsHubService,
  ) {
    this.isProd = this._env.production;
  }

  ngOnInit() {
    this._bsHubService.dispatch(RequiredVerificationsEnums.HUBCHANNEL, {event: 'clear'});

    Promise.all([
      this._bsCacheService.getItem('referrer'),
      this._bsCacheService.getItem('referrerType')
    ]).then(
      values => {
        this.signupData['custom:referrer'] = values[0] ?? '';
        this.signupData['custom:referrerType'] = values[1] ?? '';

        if (this._companyService.getCompany()?.length > 0) {
          this.company = this._companyService.getCompany();
        } else {
          this.company = 'none';
        }

      }
    )
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  signUpWithAuth0() {
    this._bsAuthService.login('signup');
  }

  loginWithAuth0() {
    this._bsAuthService.login();
  }

}

